import React from 'react'

const LocationIcon = ({ width = 21, height = 21, stroke = '#53514E' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M7.5 8.17676C8.53553 8.17676 9.375 7.33729 9.375 6.30176C9.375 5.26622 8.53553 4.42676 7.5 4.42676C6.46447 4.42676 5.625 5.26622 5.625 6.30176C5.625 7.33729 6.46447 8.17676 7.5 8.17676Z"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.5 1.30176C6.17392 1.30176 4.90215 1.82854 3.96447 2.76622C3.02678 3.70391 2.5 4.97567 2.5 6.30176C2.5 7.48426 2.75125 8.25801 3.4375 9.11426L7.5 13.8018L11.5625 9.11426C12.2487 8.25801 12.5 7.48426 12.5 6.30176C12.5 4.97567 11.9732 3.70391 11.0355 2.76622C10.0979 1.82854 8.82608 1.30176 7.5 1.30176Z"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0 0.0517578)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default LocationIcon
